
import { FirebaseListObservable, AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { firebaseConfig } from './../../../environments/firebase.config';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { Video } from './video';

@Injectable()
export class VideoService {
  private basePath: string = firebaseConfig.devfestYear + '/videos';
  private videos: FirebaseListObservable<Video[]> = null;
  //private firebaseStorage: any;

  constructor(private db: AngularFireDatabase) {
   // this.firebaseStorage = firebase.storage();
  }

  getVideoList(query?: object): FirebaseListObservable<Video[]> {
    this.videos = this.db.list(this.basePath, {
      query: query
    });
    return this.videos;
  }

}
